import { z } from "zod";
import moment from "moment";

import i18n from "../../../../../i18n";
import { Command } from "../../types";

const getTranslation = (key: string, fallback: string): string => {
  return i18n.t(`command.exportSusa.${key}`, {
    defaultValue: fallback,
  });
};

export const exportSusaRequestSchema = z
  .object({
    command: z.literal(Command.ExportSusa),
    date: z
      .custom<moment.Moment>((val) => moment.isMoment(val), {
        message: getTranslation("invalidDate", "Invalid date"),
      })
      .refine((date) => date.year() <= moment().year(), {
        message: getTranslation("futureDate", "Date cannot be in the future"),
      }),
    fromMonth: z
      .number({
        invalid_type_error: getTranslation("invalidMonth", "Invalid month"),
      })
      .int()
      .min(1)
      .max(12),
    toMonth: z
      .number({
        invalid_type_error: getTranslation("invalidMonth", "Invalid month"),
      })
      .int()
      .min(1)
      .max(12),
  })
  .refine((values) => values.toMonth >= values.fromMonth, {
    message: getTranslation(
      "invalidRange",
      "The start month cannot be after the end month"
    ),
    path: ["toMonth"],
  });

export type ExportSusaFormValues = z.infer<typeof exportSusaRequestSchema>;
